{
  "NLAMS" : [],
  "NLDZL" : [],
  "NLHAR" : [],
  "NLRTM" : [],
  "NLTNZ": [
    {
      "name": "Scheldt Maritime Services",
      "portAuthorityId": "SMS"
    }
  ],
  "NLVLI": [
    {
      "name": "Scheldt Maritime Services",
      "portAuthorityId": "SMS"
    }
  ]
}
